import { render } from "./Gps.vue?vue&type=template&id=cc0cbf0e&scoped=true"
import script from "./Gps.vue?vue&type=script&lang=js"
export * from "./Gps.vue?vue&type=script&lang=js"

import "./Gps.vue?vue&type=style&index=0&id=cc0cbf0e&scoped=true&lang=css"

import exportComponent from "E:\\01.Progetti\\GitHub\\SCIENZE_NATURALI_app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc0cbf0e"]])

export default __exports__